import { NotificationBox, NotificationContent } from '@components/_Revamp/NotificationBox'
import React from 'react'

export interface ReviewMessageBoxProps {
  children: React.ReactNode;
  rowGap?: string;
}

function ReviewMessageBox({ children, rowGap }: ReviewMessageBoxProps) {
  return (
    <NotificationBox margin={"0 0"}>
      <NotificationContent rowGap={rowGap}>
        {children}
      </NotificationContent>
    </NotificationBox>
  )
}

export default ReviewMessageBox